import type { Maybe } from '@adornis/base/utilTypes.js';
import { BuchungsheldLitElement } from '@adornis/buchungsheld-components/BuchungsheldLitElement.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('bh-icon-link')
export class BHIconLink extends BuchungsheldLitElement {
  @property({ attribute: 'icon' }) icon = 'help';
  @property({ attribute: 'text' }) text = '?';
  @property({ attribute: 'link' }) link: Maybe<string>;

  override render() {
    return html`
      <x-flex
        horizontal
        crossaxis-center
        space="sm"
        padding="xxs"
        ${css({ color: this.colors.accent, cursor: 'pointer' })}
        @click=${() => {
          if (!this.link) return;
          goTo(this.link);
        }}
      >
        <x-icon> ${this.icon} </x-icon>
        <x-text> ${this.text} </x-text>
      </x-flex>
    `;
  }
}
